var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"c-title-text",class:{
        'is-dark': _vm.type == 'dark',
    }},[_c('span',[_vm._t("left")],2),_c('span',{staticClass:"text-import"},[_vm._t("import")],2),_c('span',[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }